var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconCheckboxCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 27",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.172.939c-.28.004-.548.115-.748.312l-4.026 3.92L4.37 9.09 2.823 5.456a1.09 1.09 0 0 0-1.438-.593 1.084 1.084 0 0 0-.56 1.45l2.173 5.086a1.086 1.086 0 0 0 1.758.355l9.186-8.945c.322-.31.422-.785.253-1.198a1.089 1.089 0 0 0-1.023-.672Z",
  fill: "currentColor"
})));

export default SvgIconCheckboxCheck;